function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTezos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.1 30.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 15.05,
    cy: 15.05,
    r: 15.05,
    style: {
      fill: "#447eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.9,252.37a10.54,10.54,0,0,1,1.76.2,5,5,0,0,1,2.73,6.57,4.1,4.1,0,0,1-3,2.7,6.14,6.14,0,0,1-3.4,0,3,3,0,0,1-2.18-2.58,1.21,1.21,0,0,1,.81-1.43,1.26,1.26,0,0,1,1.58.48,1.35,1.35,0,0,1-.28,1.75l-.22.19a2.84,2.84,0,0,0,4.39-.71,5.37,5.37,0,0,0,0-4.71,2.49,2.49,0,0,0-3.31-1.17c-.41.18-.81.38-1.24.58-.21-.38.06-.59.22-.8l3.93-5.18h-5.84a22.78,22.78,0,0,0,0,2.74q0,1.5,0,3c0,.66.09,1.33.82,1.62a1.76,1.76,0,0,0,1.89-.55c.24-.22.35-.55.67-.69.46.07.5.39.4.72a2.1,2.1,0,0,1-.35.66,3.25,3.25,0,0,1-3.74.9,2.4,2.4,0,0,1-1.79-2.54c0-1.65,0-3.29,0-4.94v-1h-2.91a1.45,1.45,0,0,1,0-1.12h2.91V244.6c-.15-.39-.84-.54-.53-1.23.87.06,1.8-.28,2.69.46v3.24h7.82a2.78,2.78,0,0,1,.75.74l-4.5,4.58,0,0Z",
    transform: "translate(-674.66 -237.66)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTezos);
export default __webpack_public_path__ + "static/media/Tezos.3b2db8a3402972886dba5748b353460c.svg";
export { ForwardRef as ReactComponent };